module.exports = __webpack_public_path__ + "img/avatar_default.156c39bd.png";